import { ManageVenuesPage } from "./ManageVenuesPage";

export default ManageVenuesPage;
